import React from 'react';

import Vs from './vs';
import Info from './info';
import State from './state';

const day = ({ event }) => (
  <div className="event">
    <h2 className="event__title">{`${event.title} (#${event.id})`}</h2>

    <div className="ui divider" />

    <div className="event__body">
      <Info props={event} />
      <Vs props={event} />
      <State state={event.state} />
    </div>

  </div>
);

export default day;
